// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"934":"3125662f","977":"e30cf8e7"}[chunkId] + ".chunk.js";
};